export default {
	name:"kh",
	messages:{
		_default:function(n) {
			return "ព័ត៌មាន " + n +" មិនត្រឹមត្រូវទេ"
		},
		after: function(n, e) {
			return n +" ត្រូវតែជាកាលបរិច្ឆេទបន្ទាប់ពី " + e[0]
		},
		alpha: function(n) {
			return n + " ត្រូវតែជាអក្សរតែប៉ុណ្ណោះ"
		},
		alpha_dash: function(n) {
			return n + " អាចមានអក្សរ លេខ សញ្ញា _ ឬ - តែប៉ុណ្ណោះ"
		},
		alpha_num: function(n) {
			return n +" ត្រូវតែជាអក្សរ និងលេខតែប៉ុណ្ណោះ"
		},
		alpha_spaces: function(n) {
			return n +" ត្រូវតែជាអក្សរ និងចន្លោះមើលមិនឃើញ(Space) តែប៉ុណ្ណោះ"
		},
		before: function(n, e) {
			return n + " ត្រូវតែជាកាលបរិច្ឆេទមុន " + e[0]
		},
		between: function(n, e) {
			return n + " ត្រូវតែជាតម្លៃចន្លោះពី " + e[0] + " និង " + e[1]
		},
		confirmed: function(n) {
			return "ការបញ្ជាក់ " + n + " មិនត្រូវគ្នាទេ"
		},
		credit_card: function(n) {
			return "លេខកាតឥណទានរបស់ " + n +" មិនត្រឹមត្រូវទេ"
		},
		date_between: function(n, e) {
			return "កាលបរិច្ឆេទ " + n + " ត្រូវតែនៅចន្លោះ " + e[0] +" និង "+e[1]
		},
		date_format: function(n, e) {
			return "កាលបរិច្ឆេទ " + n +" ត្រូវតែជាទម្រង់ "+e[0]
		},
		decimal: function(n, e) {
			void 0 === e && (e = []); var t = e[0]; return void 0 === t && (t = "*"), n + " ត្រូវតែជាលេខ ហើយអាចមានចំណុចទសភាគ " + ("*" === t ? "" : t +" ខ្ទង់")
		},
		digits: function(n, e) {
			return n + " ត្រូវតែជាលេខចំនួន " + e[0] +" ខ្ទង់ប៉ុណ្ណោះ"
		},
		dimensions: function(n, e) {
			return n +" ត្រូវមានទំហំ "+e[0]+"x"+e[1]+" px"
		},
		email: function(n) {
			return n +" ត្រូវតែជាទម្រង់អ៊ីម៉ែល"
		},
		excluded: function(n) {
			return n +" ត្រូវតែជាតម្លៃដែលកំណត់តែប៉ុណ្ណោះ"
		},
		ext: function(n) {
			return n +" ប្រភេទឯកសារមិនត្រឹមត្រូវទេ"
		},
		image: function(n) {
			return n +" ត្រូវតែជារូបភាពតែប៉ុណ្ណោះ"
		},
		included: function(n) {
			return n +" ត្រូវតែជាតម្លៃដែលកំណត់តែប៉ុណ្ណោះ"
		},
		integer: function(n) {
			return n +" ត្រូវតែជាលេខចំនួនគត់"
		},
		ip: function(n) {
			return n +" មិនត្រូវតាមទម្រង់ IP address នោះទេ"
		},
		length: function(n, e) {
			var t = e[0], r = e[1]; return r ? n + " ត្រូវមានប្រវែងចន្លោះពី " + t + " និង " + r : n +" ត្រូវតែមានប្រវែង "+t
		},
		max: function(n, e) {
			return n + " ត្រូវមានប្រវែងមិនលើសពី " + e[0] +" តួអក្សរ"
		},
		max_value: function(n, e) {
			return n + " ត្រូវមានតម្លៃមិនលើសពី " + e[0]
		},
		mimes: function(n) {
			return n + " ប្រភេទឯកសារមិនត្រឹមត្រូវទេ"
		},
		min: function(n, e) {
			return n + " ត្រូវតែមានប្រវែងយ៉ាងតិច " + e[0] + " តួអក្សរ"
		},
		min_value: function(n, e) {
			return n + " ត្រូវតែមានតម្លៃពី " + e[0] + " ឡើងទៅ"
		},
		numeric: function(n) {
			return n +" ត្រូវតែជាលេខប៉ុណ្ណោះ"
		},
		regex: function(n) {
			return "ទ្រង់ទ្រាយ " + n +" មិនត្រឹមត្រូវតាមបែបបទទេ"
		},
		required: function(n) {
			return"សូមបំពេញ "+n
		},
		// size: function(n, e) {
		// 	var t, r, u, i = e[0]; return n +" ត្រូវតែមានទំហំមិនលើស "+(t=i,r=1024,u=0==(t=Number(t)*r)?0:Math.floor(Math.log(t)/Math.log(r)),1*(t/Math.pow(r,u)).toFixed(2)+" "+["Byte","KB","MB","GB","TB","PB","EB","ZB","YB"][u])
		// },
		size: (field, [size]) => `${field} ត្រូវតែមានទំហំមិនលើស ${size} KB.`,
		// size: function (field, [size]) {
		// 	return field + ' ត្រូវតែមានទំហំមិនលើស ' + size + ' KB.'
		// },
		url: function(n) {
			return n +" មិនត្រឹមត្រូវតាមទម្រង់ URL ទេ"
		}
	},
	attributes:{}
};